'use strict';

var Sugar = require('sugar-core'),
    _numberOptions = require('./var/_numberOptions');

module.exports = Sugar.Number.setOption;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/number/setOption.js
// module id = 1246
// module chunks = 0